import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {LocaisModel} from "./locais.model";
import {LocaisService} from './locais.service';
import {Funcoes} from "../funcoes";
import {PaisesService} from "../paises/paises.service";
import {Global} from "../global";


@Component({
  selector: 'app-locais-form',
  templateUrl: './locais-form.component.html'
})
export class LocaisFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  local: LocaisModel = new LocaisModel();
  listPaises = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private locaisService: LocaisService,
    private paisesService: PaisesService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_local: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      id_pais: [],
      sigla: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_local'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarLocal');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarLocal') : this.func.traduzir('front.cadastrarNovoLocal');
      }


      this.paisesService.get()
        .subscribe(
          json => {
            this.listPaises = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      if (!id) {
        return;
      }

      this.locaisService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.title = this.func.traduzir('front.editarLocal')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarLocal') + ': ' + json.Payload[0].nome;
            }
            this.local = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      values = this.local; // this.form.value;

    if (values.id_local) {
      result = this.locaisService.editar(values, values.id_local);
    } else {
      result = this.locaisService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'locais']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/locais/locais-form.component.ts